import React, { Component } from 'react';


var SelectSkills = React.createClass({
  getInitialState: function(){
    return({
      open: false,
      changeBalls: this.props.balls || []
    })
  },
  openOrClose: function(){
    // this.props.saveSpecialties(this.getListActiveSpecialties());
    if(this.state.changeBalls.length){
      this.props.addBalls(this.state.changeBalls, this.props.id)
    }
    this.setState({open: !this.state.open})
  },
  changeBall: function(newBall, id){
    var result = {changeBalls: this.state.changeBalls},
        change = false;

    if(!/^\d+$/.test(newBall)){
      if(newBall != ''){
        return;
      }
      
    }

    for(var item of result.changeBalls){
      if(item.skillId == id){
        change = true;
        item.ball = newBall;
      }
    }

    if(!change){
      result.changeBalls.push({
        skillId: id,
        ball: newBall
      })
    }

    this.setState(result)
  },
  render: function(){
    if(this.state.open){
      return(
        <div className="Specialties" style={{width: '80%'}}>
          <div onClick={this.openOrClose} className="SelectSpecialtiesOpen top">Сохранить</div>
          <div className="UserList">
            {this.props.skills.map((skill, i) => {
              var ball = 0;
              for(var item of this.state.changeBalls){
                if(item.skillId == skill.id){
                  ball = item.ball;
                }
              }
              return(
                <div key={i} className="User">
                  <div>Название навыка - {skill.nameSkill}</div>
                  <div>Проходной балл - {skill.minBall}</div>
                  <div>Тип теста - {skill.typeSkill === 0 ? 'Технический' : skill.typeSkill === 1 ? 'Психологический' : 'Опросник'}</div>
                  <input type="text" className="change" style={{right: 0, padding: '0 5px', width: 80}} placeholder="Балл" value={ball} onChange={(e)=>{
                    this.changeBall(e.target.value, skill.id)
                  }} />
                </div>
              );
            })}
          </div>
        </div>
      );
    }else{
      return (
        <div className="change" style={{right: -1, padding: '0 5px'}} onClick={this.openOrClose}>Баллы</div>
      );
    }
  }
});

export default SelectSkills;



/** WEBPACK FOOTER **
 ** ./assets/apps/AppAdmin/components/AdminPanel/components/CreatePanelTest/components/CreateQuestion/components/SelectSkills/index.jsx
 **/